import { render, staticRenderFns } from "./HomeViewCommunicate.vue?vue&type=template&id=0eca2839&scoped=true&"
import script from "./HomeViewCommunicate.vue?vue&type=script&lang=js&"
export * from "./HomeViewCommunicate.vue?vue&type=script&lang=js&"
import style0 from "./HomeViewCommunicate.vue?vue&type=style&index=0&id=0eca2839&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0eca2839",
  null
  
)

export default component.exports